import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function maxDateTodayValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const selectedDate = new Date(control.value);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (selectedDate > today) {
      return { futureDate: 'La fecha no puede ser futura.' };
    }

    return null;
  };
}
